import React, { useState } from "react";
import { Box, Flex, Link, Text, Heading, VStack } from "@chakra-ui/react";


const datasetList = [
    {
    name: "Urban Mobility Research Dataset, Video Records (Generated with the Quanser Interactive Lab)",
    Authors: ["Murat Arda Onsu, Poonam Lohan, Burak Kantarci (University of Ottawa)",
              "Aisha Syed, Matthew Andrews, Sean Kennedy (Nokia Bell Labs)" ],
    description:
      "Efficient traffic monitoring is crucial for improving route capacity, alleviating congestion, and decreasing the probability of accidents in smart cities and Intelligent Transportation Systems (ITS). In an urban traffic environment and ITS, the dataset is mainly collected from edge surveillance cameras, and intelligent models integrated into these devices utilize this data for various use cases, such as traffic management, safety, monitoring, etc. However, traditional machine learning models, which use object detection, tracking, or a heuristic approach, do not achieve optimal performance in complex, dynamic environments. To address these problems, we present a novel framework that integrates video-based perception and language-model reasoning to enhance intelligent traffic monitoring and safety. This system employs the Video Joint Embedding Predictive Architecture (VJEPA) at edge surveillance units to generate compressed video embeddings, reducing transmission overhead while enabling early situational awareness. Via V2X links, these embeddings are transmitted to vehicle units equipped with a lightweight, small language model enhanced by a visual adapter, enabling it to perform visual-textual processing and respond to real-time traffic queries related to future collision predictions and environment states such as vehicle density. Results show that the model achieves an 89% F1 score for predicting the future collision events. ",
    format: "*.mp4",
    date: "Sat, 11/22/2025",
    link: "https://dx.doi.org/10.21227/jazm-2z18",
    imgIcon: "dataset_icon 1.png",
  },
  {
    name: "Urban Mobility Research Dataset (Generated with the Quanser Interactive Lab)",
    Authors: ["Murat Arda Onsu, Poonam Lohan, Burak Kantarci (University of Ottawa)",
              "Aisha Syed, Matthew Andrews, Sean Kennedy (Nokia Bell Labs)" ],
    description:
      "It is an urban city environment dataset containing camera captions of 1898x1898 RGB color images. 4 different cameras are attached to various places in the environment to collect data in different driving scenarios.",
    format: "*.jpg",
    date: "Thu, 04/24/2025",
    link: "https://dx.doi.org/10.21227/t4xs-rf05",
    imgIcon: "dataset_icon 2.png",
  },
  {
    name: "Revisiting Table Detection Datasets for Visually Rich Documents",
    Authors: ["Bin Xiao, Murat Simsek, Burak Kantarci (University of Ottawa)",
              "Ala Abu Alkheir (Lytica Inc.)"],
    description:
      "Table Detection is a fundamental task for visually rich document understanding. However, popular public datasets widely used in related studies have inherent limitations, including noisy and inconsistent samples, limited training samples and limited data sources. These limitations make these datasets unreliable for evaluating the model performance and cannot reflect the actual capacity of models. Therefore, this study revisits some open-source datasets with high-quality annotations, identifies and cleans the noise, and aligns the annotation definitions of these datasets to merge a larger dataset, Open-Tables. Moreover, to enrich the data sources, we propose a new ICT-TD dataset using the PDF files of Information and Communication Technologies (ICT) commodities, a different domain containing unique samples that hardly appear in open-source datasets. To ensure the label quality of the dataset, we annotated the dataset manually following the guidance of a domain expert. The proposed dataset is challenging and can be a sample of actual cases in the business context. We built strong baselines using various state-of-the-art object detection models. Experimental results show that the domain differences among existing open-source datasets are minor despite having different data sources. Our proposed Open-Tables and ICT-TD can provide a more reliable evaluation for models because of their high quality and consistent annotations. Besides, they are more suitable for cross-domain settings. Our experimental results show that in the cross-domain setting, benchmark models trained with cleaned Open-Tables dataset can achieve 0.6%-2.6% higher weighted average F1 than the corresponding ones trained with the noisy version of Open-Tables.",
    format: "",
    date: "Mon, 04/08/2024",
    link: "https://dx.doi.org/10.21227/sh17-hr68",
    imgIcon: "dataset_icon 3-6-7.png",
  },
  {
    name: "SCVIC-TS-2022: Network intrusion data with original raw network packets",
    Authors: ["Jinxin Liu, Murat Simsek, Burak Kantarci (University of Ottawa)",
              "Michele Nogueira  (Federal University of Minas Gerais)"],
    description:
      "To apply Time Series Network Flow Meter (TS-NFM), a network intrusion dataset must have original raw network packets rather than extracted features and complete labeling information; consequently, this dataset uses the CIC-IDS-2017 dataset (I. Sharafaldin, A. Habibi Lashkari, and A. A. Ghorbani, “Toward Generating a New Intrusion Detection Dataset and Intrusion Traffic Characterization:,” in Proc. of the 4th Intl. Conf. on Information Systems Security and Privacy, 2018). The raw network packets (PCAP format) are fed into the TS-NFM proposed in our paper*  with a time window of two minutes (same to the extracted features from CIC-IDS-2017), resulting in the SCVIC-TS-2022 dataset. MTS's maximum length L is 511,681 due to the network's fast speed. The number of features/dimensions d is thirteen, which includes the direction of a packet, IAT, size in bytes, and ten TCP flags",
    format: "*.csv;*.json;*.xlsx;*.pkl",
    date: "Sun, 09/03/2023",
    link: "https://dx.doi.org/10.21227/qm9h-8c05",
    imgIcon: "dataset_icon 4.png",
  },
  {
    name: "SCVIC-CIDS-2021: Collaborative Feature Maps of Networks and Hosts for Intrusion Detection",
    Authors: ["Jinxin Liu, Murat Simsek, Burak Kantarci (University of Ottawa)",
              "Mehran Bagheri, Petar Djukic (Ciena)"],
    description:
      "SCVIC-CIDS-2021 is derived from the meta-data (i.e., network packets, system logs and labeling information) from the well-known benchmark dataset, CIC-IDS-2018 (Iman Sharafaldin, Arash Habibi Lashkari, and Ali A. Ghorbani, “Toward Generating a New Intrusion Detection Dataset and Intrusion Traffic Characterization”, 4th International Conference on Information Systems Security and Privacy (ICISSP), Portugal, January 2018 ) .",
    format: ".pkl",
    date: "Sat, 09/02/2023",
    link: "https://dx.doi.org/10.21227/ykz8-sy55",
    imgIcon: "dataset_icon 5.png",
  },
  {
    name: "SCVIC-APT-2021",
    Authors: ["Jinxin Liu, Yu Shen, Murat Simsek, Burak Kantarci, Hussein T. Mouftah (University of Ottawa)",
              "Mehran Bagheri, Petar Djukic (Ciena)"],
    description:
      "In order to define a benchmark for Machine Learning (ML)-based Advanced Persistent Threat (APT) detection in the network traffic, we create a dataset named SCVIC-APT-2021, that can realistically represent the contemporary network architecture and APT characteristics.  Please cite the following original article where this work was initially presented:",
    format: "*.csv",
    date: "Mon, 09/26/2022",
    link: "https://dx.doi.org/10.21227/g2z5-ep97",
    imgIcon: "dataset_icon 3-6-7.png",
  },
  {
    name: "SCVIC-CIDS-2022: Bridging Networks and Hosts via Machine Learning-Based Intrusion Detection",
    Authors: ["Jinxin Liu, Murat Simsek, Burak Kantarci (University of Ottawa)",
              "Mehran Bagheri, Petar Djukic (Ciena)"],
    description:
      "J. Liu, M. Simsek, B. Kantarci, M. Bagheri, P. Djukic, \"Bridging Networks and Hosts via Machine Learning-Based Intrusion Detection\"; under review in IEEE Transactions on Dependable and Secure Computing.",
    format: ".pkl",
    date: "Wed, 09/14/2022",
    link: "https://dx.doi.org/10.21227/dn9v-3278",
    imgIcon: "dataset_icon 3-6-7.png",
  },
];

function Datasets() {
  // max characters before showing "read more"
  const MAX_LENGTH = 250;

  return (
    <Box 
      p={8}
      //maxW="900px"                     // keeps desktop neat
      mx="auto"                        // center content on desktop
      w={{ base: "99%", md: "80%" }}   // left/right padding on mobile (10%)
    >
      <Heading mb={6} fontSize={{ base: "2xl", md: "3xl" }} textAlign="center">
        IEEE Dataport Datasets
      </Heading>

      <VStack spacing={6} align="stretch">
        {datasetList.map((ds, index) => {
          const [expanded, setExpanded] = useState(false);

          const isLong = ds.description.length > MAX_LENGTH;
          const textToShow = expanded
            ? ds.description
            : ds.description.slice(0, MAX_LENGTH);

          return (
            <Box
              key={index}
              p={5}
              borderWidth="1px"
              borderRadius="lg"
              shadow="md"
              _hover={{ shadow: "xl", transition: "0.2s" }}
            >
              <Flex
                direction={{ base: "column", md: "row" }}
                align={{ base: "center", md: "flex-start" }}
                gap={4}
                mb={4}
              >
                {/* Desktop: Image first -- Mobile: Image after title */}
                {ds.imgIcon && (
                  <Box
                    as="img"
                    src={ds.imgIcon}
                    alt={`${ds.name} thumbnail`}
                    boxSize={{ base: "65%", md: "185px" }}
                    objectFit="cover"
                    borderRadius="md"
                    shadow="md"
                    mx={{ base: "auto", md: 0 }}         // center image on mobile
                    order={{ base: 2, md: 1 }}           // mobile: under title, desktop: left of text
                    mt={{ base: 2, md: 0 }}
                  />
                )}

                <Box flex="1" order={{ base: 1, md: 2 }}>
                  {/* Title */}
                  <Text
                    fontSize="xl"
                    fontWeight="bold"
                    textAlign={{ base: "center", md: "left" }}
                    mb={2}
                  >
                    {ds.name}
                  </Text>

                  {/* Authors come here on desktop (right of image), but BELOW image on mobile */}
                  {Array.isArray(ds.Authors) && ds.Authors.length > 0 && (
                    <>
                      <Text fontSize={{ base: "sm", md: "md" }} color="gray.600">
                        <b>Citation Author(s):</b>
                      </Text>

                      {ds.Authors.map((line, i) => (
                        <Text key={i} fontSize={{ base: "sm", md: "md" }} color="gray.600" ml={{ md: 0 }}>
                          &emsp;{line}
                        </Text>
                      ))}
                    </>
                  )}
                </Box>
              </Flex>

              <Text fontSize={{ base: "sm", md: "md" }} color="gray.600"  mt={3}>
                    <b>Description:</b>
              </Text>
              <Text fontSize={{ base: "sm", md: "md" }} color="gray.700">
                {textToShow}
                {!expanded && isLong && "..."}
              </Text>

              {isLong && (
                <Text
                  fontSize="sm"
                  color="blue.500"
                  mt={1}
                  cursor="pointer"
                  onClick={() => setExpanded(!expanded)}
                >
                  {expanded ? "Read less" : "Read more"}
                </Text>
              )}

              <Text fontSize={{ base: "sm", md: "md" }} mt={2} color="gray.600">
                <b>Format:</b> {ds.format}
              </Text>

              <Text fontSize={{ base: "sm", md: "md" }} color="gray.600">
                <b>Published:</b> {ds.date}
              </Text>

              <Flex mt={3}>
                <Link
                  href={ds.link}
                  color="blue.500"
                  fontWeight="bold"
                  isExternal
                >
                  IEEE Dataport Link →
                </Link>
              </Flex>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
}

export default Datasets;
